<template>
  <el-dialog
      title="新增"
      append-to-body
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">

    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="90px"
        v-loading="loading"
    >
      <el-form-item label="手机号" prop="phone">
        <el-input
            clearable
            v-model="ruleForm.phone"
            placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productId" label="商品">
        <el-select v-model="ruleForm.productId" placeholder="请选择" @change="productChange">
          <el-option
              v-for="item in productData"
              :key="item.productId"
              :label="item.productName"
              :value="item.productId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到期时间" prop="expireTime" v-if="ruleForm.serviceType == 'time'">
        <el-date-picker
            v-model="ruleForm.expireTime"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="次数" prop="count" v-if="ruleForm.serviceType == 'count'">
        <el-input-number v-model="ruleForm.count" :step="1" step-strictly :min="1" size="mini"></el-input-number>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" type="primary" @click="submitForm">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: "addDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      productData: [],
      ruleForm: {
        expireTime: null,
        count: 1
      },
      rules: {
        phone: [{required: true, message: "请输入手机号", trigger: "blur"}],
        productId: [{required: true, message: "请选择商品", trigger: "blur"}],
        expireTime: [{required: true, message: "请选择日期", trigger: "blur"}],
        count: [{required: true, message: "请输入次数", trigger: "blur"}],
      }
    }
  },
  created() {
    this.getProductData()
  },
  methods: {
    submitForm() {
      this.loading = true
      this.$refs.ruleForm.validate(async value => {
        if (value) {
          this.$http.post(this.$api.customerEnterprise.getCustomerService, this.ruleForm).then((res) => {
            if (res.data.code == 200) {
              this.loading = false
              this.updateDialog(false)
              this.$emit('getList');
              this.$message.success(res.data.msg);
            } else {
              this.loading = false
              this.$message.error(res.data.msg);
            }
          })
        }
      });
    },
    productChange(e) {
      this.ruleForm.expireTime = null
      this.ruleForm.count = null
      this.productData.forEach(item => {
        if (item.productId === e) {
          this.ruleForm.serviceType = item.serviceType
        }
      })
    },
    getProductData() {
      this.$http.get(this.$api.customerEnterprise.getOnlineProductInfoList).then((res) => {
        this.productData = res.data.data
      })
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.updateDialog(false)
          })
          .catch(() => {
          });
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
